<template>
  <div>
    <GmapMap
      ref="mapRef"
      :map-type-id="mapTypeId"
      :center="mapCenter"
      :zoom="zoom"
      :style="mapStyle"
      :options="mapOptions"
    >
      <GmapMarker
        v-if="currentPosition"
        :position="currentPosition"
        :clickable="false"
        :icon="{
          url: getMarkerIcon(markerColour),
          scaledSize: { width: 24, height: 32 }
        }"
      />
      <GmapMarker
        v-if="currentPosition"
        :position="currentPosition"
        :icon="{
          url: getPositionIcon(),
          scaledSize: { width: 32, height: 32 }
        }"
      />

      <template v-slot:visible>
        <div :class="$style.positionControl" v-if="!initializing">
          <button
            ref="positionBtn"
            :disabled="loadingPosition"
            :class="{
              [$style.disabled]: !currentPositionAvailable
            }"
            @click="handlePositionIconClick"
          >
            <Loading
              v-if="loadingPosition"
              :class="$style.spinner"
              :size="20"
              backgroundColor="transparent"
            />
            <PositionIcon v-else />
          </button>
        </div>
      </template>
    </GmapMap>
  </div>
</template>

<script>
import { Map as GmapMap, Marker as GmapMarker, gmapApi } from "gmap-vue";
import { getMarkerIcon, getPositionIcon } from "./helpers";
import PositionIcon from "../../assets/svg/Position.vue";
import Loading from "../Loading/Loading.vue";

const zoomDirectionEnum = {
  UNSET: "UNSET",
  OUT: "OUT",
  IN: "IN",
  PREVENT: "PREVENT"
};

export default {
  name: "Map",
  components: {
    GmapMap,
    GmapMarker,
    PositionIcon,
    Loading
  },
  props: {
    minHeight: {
      type: String,
      default: "350px"
    },
    height: {
      type: String,
      default: "100%"
    },
    width: {
      type: String,
      default: "100%"
    },
    marker: {
      type: Object,
      default: () => {}
    },
    mapTypeId: {
      type: String,
      default: "roadmap"
    },
    mapZoom: {
      type: Number,
      default: 10
    },
    geolocation: {
      type: Object,
      default: () => {}
    },
    markerColour: {
      type: String,
      default: ""
    }
  },
  computed: {
    mapStyle: function() {
      return `height: ${this.height};width: ${this.width};min-height: ${this.minHeight};`;
    },
    google: gmapApi
  },
  data() {
    return {
      initializing: true,
      loadingPosition: false,
      getPositionIcon,
      getMarkerIcon,
      dirty: false,
      mapCenter: this.geolocation || {
        lat: -1,
        lng: -1
      },
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true
      },
      map: undefined,
      currentPosition: this.geolocation || undefined,
      zoom: this.mapZoom,
      boundsChangedListener: undefined,
      zoomDirection: zoomDirectionEnum.UNSET,
      currentPositionAvailable: true
    };
  },
  methods: {
    initDragListener() {
      this.map.addListener("dragstart", () => {
        this.dirty = true;
      });
    },
    initZoomChangeListener() {
      this.map.addListener("zoom_changed", () => {
        this.zoom = this.map.getZoom();
      });
    }
  },
  watch: {
    geolocation: function(newGeolocation, oldGeolocation) {
      this.mapCenter = newGeolocation;
    }
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then(map => {
      this.map = map;
      this.initDragListener();
      this.initZoomChangeListener();
      this.boundsChangedListener = this.map.addListener(
        "bounds_changed",
        () => {
          this.google.maps.event.removeListener(this.boundsChangedListener);
          this.boundsChangedListener = undefined;
        }
      );
    });
  }
};
</script>
